var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiteIconBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3854_3994",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3854_3994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.67773 13.3442H16.6777V5.01082H6.67773V13.3442ZM6.67773 15.0108C6.2194 15.0108 5.82704 14.8476 5.50065 14.5212C5.17426 14.1948 5.01107 13.8025 5.01107 13.3442V3.34416C5.01107 2.88582 5.17426 2.49346 5.50065 2.16707C5.82704 1.84068 6.2194 1.67749 6.67773 1.67749H16.6777C17.1361 1.67749 17.5284 1.84068 17.8548 2.16707C18.1812 2.49346 18.3444 2.88582 18.3444 3.34416V13.3442C18.3444 13.8025 18.1812 14.1948 17.8548 14.5212C17.5284 14.8476 17.1361 15.0108 16.6777 15.0108H6.67773ZM3.3444 18.3442C2.88607 18.3442 2.49371 18.181 2.16732 17.8546C1.84093 17.5282 1.67773 17.1358 1.67773 16.6775V5.01082H3.3444V16.6775H15.0111V18.3442H3.3444Z",
    fill: "#135FC2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteIconBlue);
export default __webpack_public_path__ + "static/media/SiteIconBlue.99cd84f10771bcbb75e2fcfb2beae763.svg";
export { ForwardRef as ReactComponent };